import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Observable, map } from 'rxjs';

@Injectable()
export class CleanResponseInterceptor implements HttpInterceptor {

  // Keys to skip cleaning inside JSON
  private keyWhitelist: string[] = ['rawHtml'];

  // API endpoints to skip cleaning
  private apiWhitelist: string[] = ['GetCaseNotes', 'SaveCaseNotes', 'CreateCaseNotes'];

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Check if request URL matches any whitelisted API
    if (this.apiWhitelist.some(url => req.url.includes(url))) {
      return next.handle(req); // Skip cleaning
    }

    return next.handle(req).pipe(
      map(event => {
        if (event instanceof HttpResponse && event.body) {
          const cleanedBody = this.cleanObject(event.body);
          return event.clone({ body: cleanedBody });
        }
        return event;
      })
    );
  }

  private cleanObject(obj: any): any {
    if (Array.isArray(obj)) {
      return obj.map(item => this.cleanObject(item));
    } else if (obj !== null && typeof obj === 'object') {
      const cleaned: any = {};
      for (const key of Object.keys(obj)) {
        if (this.keyWhitelist.includes(key)) {
          cleaned[key] = obj[key];
        } else {
          cleaned[key] = this.cleanObject(obj[key]);
        }
      }
      return cleaned;
    } else if (typeof obj === 'string') {
      return this.cleanString(obj);
    }
    return obj;
  }

  private cleanString(value: string): string {
    let decoded = value.replace(/&amp;/g, '&');
    decoded = decoded.replace(/&#(\d+);?/g, (_, code) =>
      String.fromCharCode(parseInt(code, 10))
    );
    decoded = decoded.replace(/[\n\t•]/g, ' ');
    return decoded.replace(/\s+/g, ' ').trim();
  }
}
